/**
 * Skip-to-content (a11y): first tabbable element of the app. It is visually
 * hidden until it receives keyboard focus, at which point it appears as a
 * floating button; activating it moves focus to `<main>` (#main-content),
 * skipping the navigation. Theme-aware (tokens) and without affecting the layout.
 */
import { msg } from "@lingui/core/macro";
import { useI18n } from "@/providers/i18n-provider";

const MAIN_CONTENT_ID = "main-content";

export function SkipToContent() {
  const { t } = useI18n();
  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      class="sr-only z-[100] rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-lg focus-visible:not-sr-only focus-visible:fixed focus-visible:left-4 focus-visible:top-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      onClick={(e) => {
        const target = document.querySelector<HTMLElement>(`#${MAIN_CONTENT_ID}`);
        if (target) {
          e.preventDefault();
          target.setAttribute("tabindex", "-1");
          target.focus();
        }
      }}
    >
      {t(msg`Skip to content`)}
    </a>
  );
}

export { MAIN_CONTENT_ID };
